import { createFormItem } from "@/component-create/utils/create-form-item"
import { SearchForm } from "@/component-create/SearchForm"
import { FORM_ITEM } from "@/components/form/enums"

export function searchForm(el: Element) {
  const searchForm = new SearchForm(el, items, { labelWidth: '80px' })
  return searchForm
}

const items = [
  createFormItem('参数名称', 'paramName', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' }),
  createFormItem('参数键', 'paramKey', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' }),
]